let Hooks = {}

Hooks.CurrencyInput = {
    mounted() {
        const input = this.el.querySelector('input[type="number"]');
        const form = this.el.closest("form");

        if (!input || !form) return;

        const updateHiddenInput = () => {
            const hiddenInput = document.getElementById(input.dataset.inputId);
            if (hiddenInput) {
                hiddenInput.value = Math.round(parseFloat(input.value || 0) * 100);
            }
        };

        input.addEventListener("input", updateHiddenInput)
        form.addEventListener("submit", updateHiddenInput)
    }
};


export {Hooks}